import React from 'react';
import { OrganizationTabParamList } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import useOrganizationInvitations from '../../../../../hooks/api/useOrganizationUserInvitations';
import OrganizationInvitationDetails from '../../../../shared/OrganizationInvitations/OrganizationInvitationDetails';

export type OrganizationInvitationScreenOwnProps = {};

export type OrganizationInvitationScreenProps = OrganizationInvitationScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'organization-invitation'>;
};

const OrganizationInvitationScreen: React.FC<OrganizationInvitationScreenProps> = (props) => {
    const { invitation, isLoadingInvitation } = useOrganizationInvitations({
        invitationId: props.route.params.invitationId,
    });
    return (
        <AnimateLoadedContent isLoading={!invitation || isLoadingInvitation}>
            {() => (
                <ActionButtonLayout scrollable>
                    <MainContentContainer>
                        <OrganizationInvitationDetails invitation={invitation!} />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationInvitationScreen);
